/* @ngInject */
function DateInputController (Utils) {
  var ctrl = this

  ctrl.$onInit = function () {
    this.today = moment()
    this.value = moment(ctrl.field.value) || moment()
    this.formattedValue = moment(ctrl.field.value)
    this.onChange({ value: moment(this.value).toISOString() })

    if (ctrl.field.rules.length) {
      const aRule = ctrl.field.rules.filter(elem => elem.type === 'GREATER_THAN_EQUALS')
      const daysToBeAdded = Number(aRule[0].value) + 1
      this.today = Utils.getMinDate(daysToBeAdded)
    }
  }

  ctrl.$onChanges = ctrl.$onInit
}

export { DateInputController }
